import Vue from 'vue';
import noty from './noty.service';

export default {
    async getSettingsByClient(clientId) {
        return (await Vue.http.get(`/api/baas/settings/byclient/${clientId}`)).data;
    },
    async save(clientId, settings) {
        await Vue.http.post(`/api/baas/settings/byclient/${clientId}`, settings);
        noty.success('Settings saved successfully');
    }
};



// WEBPACK FOOTER //
// ./src/services/baas.service.js